// Kept in contract with backend/src/services/rivalAdvancedReport.js.
const definitions = [
  ['xgFor', 'EXPECTED_GOALS', 'aFavor', 'attack'],
  ['xgAgainst', 'EXPECTED_GOALS', 'enContra', 'defense'],
  ['onTargetFor', 'SHOTS_ON_TARGET', 'aFavor', 'attack'],
  ['onTargetAgainst', 'SHOTS_ON_TARGET', 'enContra', 'defense'],
  ['chancesFor', 'BIG_CHANCES', 'aFavor', 'attack'],
  ['possession', 'POSSESSION', 'aFavor', 'control', true],
  ['shotsFor', 'SHOTS_TOTAL', 'aFavor', 'attack'],
  ['shotsAgainst', 'SHOTS_TOTAL', 'enContra', 'defense'],
  ['chancesAgainst', 'BIG_CHANCES', 'enContra', 'defense'],
  ['passAccuracy', 'PASSES_ACCURACY', 'aFavor', 'control', true],
  ['corners', 'CORNERS', 'aFavor', 'control'],
];
const numeric = value => value !== null && value !== undefined && String(value).trim() !== ''
  && typeof value !== 'boolean' && ['number', 'string'].includes(typeof value)
  && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
const same = (a, b) => a != null && b != null && String(a) === String(b);
export const reportAdvancedScope = (choice, home) =>
  ['total', 'local', 'visitante'].includes(choice) ? choice : home === true ? 'local' : home === false ? 'visitante' : 'total';
export const reportAdvancedPeriod = choice =>
  ['partido', 'primeraParte', 'segundaParte'].includes(choice) ? choice : 'partido';
export function reportAdvancedCompatible(record, context) {
  return Boolean(record?.estadisticasAvanzadas?.fuente && context
    && ['idCompeticion', 'idGrupo', 'idTemporada', 'idEquipo'].every(key => same(record[key], context[key])));
}
export function reportAdvancedModel(record, context, scope = 'total', period = 'partido') {
  const valid = reportAdvancedCompatible(record, context);
  const data = valid ? record.estadisticasAvanzadas[scope] : null;
  const sample = numeric(data?.[period]?.partidosConDatos);
  const rows = definitions.map(([key, id, direction, group, percentage = false]) => {
    const metric = Object.values(data?.[period]?.[direction] || {}).find(category => category?.[id])?.[id];
    const count = numeric(metric?.partidosConDatos);
    let value = null;
    if (count > 0 && sample >= count && Number.isInteger(count)) {
      if (metric.operacion === 'porcentaje') {
        const hits = numeric(metric.aciertos), attempts = numeric(metric.intentos);
        if (attempts > 0 && hits !== null && hits <= attempts) value = hits / attempts * 100;
      } else if (['suma', 'media'].includes(metric.operacion)) {
        const sum = numeric(metric.suma);
        value = sum !== null ? sum / count : Object.hasOwn(metric, 'suma') ? null : numeric(metric.media);
      }
    }
    if (percentage && value > 100) value = null;
    return { key, id, direction, group, percentage, value, sample: count };
  });
  return { available: valid && (sample > 0 || numeric(data?.tactica?.partidosConSistema) > 0),
    sample, scope, period, rows, tactics: data?.tactica || null,
    partial: numeric(data?.partidosCoberturaIndividualParcial),
    source: valid ? record.estadisticasAvanzadas.fuente : null };
}
export function reportAdvancedTactics(tactics, players = []) {
  const sample = numeric(tactics?.partidosConSistema);
  const systems = Object.entries(tactics?.sistemas || {}).filter(([name, data]) =>
    /^\d+(?:-\d+)+$/.test(name) && name.split('-').reduce((sum, n) => sum + Number(n), 0) === 10
    && numeric(data?.partidos) > 0 && sample >= Number(data.partidos))
    .map(([name, data]) => ({ name, count: Number(data.partidos), share: Number(data.partidos) / sample * 100 }))
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
  const candidate = tactics?.alineacionMasRepetida;
  const lineup = candidate?.jugadores ? candidate : systems.length
    ? { sistema: systems[0].name, ...tactics.sistemas[systems[0].name].onceMasRepetido } : null;
  const formation = String(lineup?.sistema || '').split('-').map(Number);
  const ids = lineup?.jugadores;
  const valid = systems.some(system => system.name === lineup?.sistema)
    && formation.every(n => Number.isInteger(n) && n > 0) && formation.reduce((a, b) => a + b, 0) === 10
    && Array.isArray(ids) && ids.length === 11 && ids.every(id => ['string', 'number'].includes(typeof id) && String(id).trim() !== '')
    && new Set(ids.map(String)).size === 11 && numeric(lineup.veces) > 0
    && numeric(tactics?.sistemas?.[lineup.sistema]?.partidosConOnce) >= Number(lineup.veces);
  return { sample, systems, formation: valid ? lineup.sistema : null, repetitions: valid ? Number(lineup.veces) : null,
    players: valid ? ids.map(id => ({ id, name: players.find(player => same(player.idJugador ?? player.codJugador, id))?.nombre || null })) : [] };
}
